import {
  SET_POLICIES_TO_ACCEPT,
  UNSET_POLICIES_TO_ACCEPT,
  REQUEST_POLICIES,
  RECEIVE_POLICIES,
  SHOW_ACCEPT_POLICIES_MODAL_REQUEST,
  HIDE_ACCEPT_POLICIES_MODAL_REQUEST,
  USER_IS_CONSIDERING_DECLINING_POLICIES,
  USER_IS_NOT_CONSIDERING_DECLINING_POLICIES
} from '../actions/policies'

const initialState = {
  isFetching: false,
  items: [],
  policiesToAccept: [],
  showAcceptPoliciesModal: false,
  userIsConsideringDecliningPolicies: false
}

export function policies(state = initialState, action) {
  switch (action.type) {
    case REQUEST_POLICIES:
      return Object.assign({}, state, {
        isFetching: true
      })
    case RECEIVE_POLICIES:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.policies
      })
    case SET_POLICIES_TO_ACCEPT:
      return Object.assign({}, state, {
        policiesToAccept: action.policiesToAccept
      })
    case UNSET_POLICIES_TO_ACCEPT:
      return Object.assign({}, state, {
        policiesToAccept: []
      })
    case SHOW_ACCEPT_POLICIES_MODAL_REQUEST:
      return Object.assign({}, state, {
        showAcceptPoliciesModal: true
      })
    case HIDE_ACCEPT_POLICIES_MODAL_REQUEST:
      return Object.assign({}, state, {
        showAcceptPoliciesModal: false
      })
    case USER_IS_CONSIDERING_DECLINING_POLICIES:
      return Object.assign({}, state, {
        userIsConsideringDecliningPolicies: true
      })
    case USER_IS_NOT_CONSIDERING_DECLINING_POLICIES:
      return Object.assign({}, state, {
        userIsConsideringDecliningPolicies: false
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/policies.js